import {AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TerminalService} from 'primeng/components/terminal/terminalservice';
import {Subscription} from 'rxjs/Subscription';
import {ServerNotificationService} from "@catcore/services/server-notification.service";
import {DisplayTypes} from "@catui/components/panel/types";
import {ClientMessage} from "@catcore/types/message";
import {NotificationsService} from "@catcore/services";

@Component({
  selector: 'cat-server-notifications',
  templateUrl: './server-notifications.component.html',
  styleUrls: ['./server-notifications.component.scss']
})
export class ServerNotificationsComponent implements OnInit, OnDestroy, AfterViewChecked {

  @ViewChild('scrollDiv') private myScrollContainer: ElementRef;

  subscription: Subscription;

  display: boolean = false;
  messages: ClientMessage[] = [];

  panelDisplayType = DisplayTypes;

  progressValue = 0;
  progressStep = 0;
  totalSteps = 0;
  processRunning = false;

  MSG_TYPE_PROCESS_START = 0;
  MSG_TYPE_PROCESS_END = 2;
  MSG_TYPE_ERROR = 3;
  MSG_TYPE_WARNING = 4;

  constructor(private terminalService: TerminalService,
              private serverNotificationService: ServerNotificationService,
              private notificationService: NotificationsService) {
  }

  ngOnInit() {
    this.serverNotificationService.visibleState.subscribe((visible) => {
      this.display = visible;
    });

    this.serverNotificationService.messages.subscribe((msgs) => {
        msgs.forEach((msg) => {
          this.consumeMessage(msg);
        });
      },
      (error) => {
        console.log('Websocket error: ', error);
      },
      () => {
        console.log('Websocket completed');
      }
    );
  }

  protected consumeMessage(msg) {
    switch(msg.type) {
      case this.MSG_TYPE_PROCESS_START:
        this.processRunning = true;
        this.progressStep = 0;
        this.totalSteps = msg.totalSteps;
        if (msg.message) {
          this.messages.push({
            timestamp: msg.ts,
            message: msg.message,
            strong: true,
            linebreakBefore: true,
            warning: false,
            error: false
          });
        }
        break;
      case this.MSG_TYPE_PROCESS_END:
        this.progressStep = this.totalSteps;
        this.processRunning = false;
        setTimeout(() => this.serverNotificationService.hide(), 2000);
        if (msg.message) {
          this.messages.push({
            timestamp: msg.ts,
            message: msg.message,
            strong: true,
            warning: false,
            error: msg.success !== 'true'
          });
          if (msg.async === 'true') {
            // Alert the user with a notification, since this is not done by the http response
            const summary = (msg.summary ? msg.summary : 'Process Finished');
            if (msg.success === 'true') {
              this.notificationService.success(summary, msg.message);
            } else {
              this.notificationService.error(summary, msg.message);
            }
          }
        }
        break;
      case this.MSG_TYPE_ERROR:
        // Error messages should only be used by asynchronous processes, all others should just return a http failure
        this.notificationService.error(
          msg.summary,
          msg.message
        );
        this.messages.push({
          timestamp: msg.ts,
          message: msg.summary + ': ' + msg.message,
          strong: true,
          warning: false,
          error: true
        });
        break;
      default:
        const warning: boolean = (msg.type === this.MSG_TYPE_WARNING);
        if (msg.step) {
          this.progressStep = msg.step;
        }
        if (msg.totalSteps) {
          this.totalSteps = msg.totalSteps;
        }
        this.processRunning = true;
        if (msg.message) {
          this.messages.push({
            timestamp: msg.ts,
            message: msg.message,
            warning: warning,
            error: false
          });
        }
    }
    this.updateProgress();
  }

  protected updateProgress() {
    if (this.totalSteps > 0) {
      this.progressValue = Math.round(this.progressStep * 100 / this.totalSteps);
      if (this.progressValue > 100) {
        this.progressValue = 100;
      }
    } else {
      this.progressValue = 0;
    }
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onHide() {
    this.serverNotificationService.visibleState.next(false);
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch(err) { }
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/components/server-notifications/server-notifications.component.ts